import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-licence-agrement',
  templateUrl: './licence-agrement.component.html',
  styleUrls: ['./licence-agrement.component.scss']
})
export class LicenceAgrementComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<LicenceAgrementComponent>
  ) { }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }
}
